export default {
    id: "3092f067-a5db-4d69-a9dc-df6d88b08344",
    icon: "mdi-arrow-right",
    name: "shapeArrow",
    title: "Shape Arrow",
    description: "A block arrow",
}